export default __webpack_public_path__ + "static/media/recent-icon.78e5bbec.svg";